import React from "react";
import { useOverrides } from "@quarkly/components";
import { Text, Link, Box, Section } from "@quarkly/widgets";
const defaultProps = {
	"padding": "60px 0 30px 0",
	"background": "--color-dark",
	"quarkly-title": "Footer-16"
};
const overrides = {
	"box": {
		"kind": "Box",
		"props": {
			"display": "flex",
			"md-flex-direction": "column",
			"md-align-items": "flex-start",
			"justify-content": "space-between",
			"padding": "30px 0px 0px 0px",
			"border-width": "1px 0 0 0",
			"border-style": "solid",
			"border-color": "--color-light",
			"lg-flex-direction": "column",
			"align-items": "flex-start"
		}
	},
	"box1": {
		"kind": "Box",
		"props": {
			"min-width": "100px",
			"min-height": "100px",
			"display": "flex",
			"lg-margin": "0px 0px 20px 0px",
			"sm-flex-direction": "column"
		}
	},
	"box2": {
		"kind": "Box",
		"props": {
			"min-width": "100px",
			"min-height": "100px",
			"margin": "0px 50px 0px 0px",
			"display": "flex",
			"flex-direction": "column"
		}
	},
	"text": {
		"kind": "Text",
		"props": {
			"margin": "0px 0px 25px 0px",
			"font": "normal 500 18px/1.2 --fontFamily-sansHelvetica",
			"color": "--light",
			"md-margin": "0px 0px 20px 0px",
			"letter-spacing": "1px",
			"children": "CONTACTS"
		}
	},
	"link": {
		"kind": "Link",
		"props": {
			"href": "/",
			"color": "#c3c8d0",
			"text-decoration-line": "initial",
			"font": "normal 300 16px/1.5 --fontFamily-sans",
			"display": "inline-block",
			"text-align": "left",
			"margin": "0px 0px 5px 0px",
			"hover-color": "white",
			"children": "+19022214154"
		}
	},
	"link1": {
		"kind": "Link",
		"props": {
			"href": "/",
			"color": "#c3c8d0",
			"text-decoration-line": "initial",
			"font": "normal 300 16px/1.5 --fontFamily-sans",
			"display": "inline-block",
			"margin": "0px 0px 15px 0px",
			"text-align": "center",
			"hover-color": "white",
			"children": "support@stack.com"
		}
	},
	"box3": {
		"kind": "Box",
		"props": {
			"min-width": "100px",
			"min-height": "100px"
		}
	},
	"text1": {
		"kind": "Text",
		"props": {
			"margin": "0px 0px 25px 0px",
			"font": "normal 500 18px/1.2 --fontFamily-sansHelvetica",
			"color": "--light",
			"md-margin": "0px 0px 20px 0px",
			"letter-spacing": "1px",
			"children": "ADDRESS"
		}
	},
	"text2": {
		"kind": "Text",
		"props": {
			"margin": "0px 0px 20px 0px",
			"color": "#c3c8d0",
			"font": "normal 300 16px/1.7 --fontFamily-sans",
			"border-color": "#b8acac",
			"md-margin": "0px 0px 15px 0px",
			"children": "6355 Liverpool St, Halifax"
		}
	},
	"box4": {
		"kind": "Box",
		"props": {
			"display": "flex",
			"md-align-self": "stretch",
			"sm-flex-direction": "column"
		}
	},
	"link2": {
		"kind": "Link",
		"props": {
			"padding": "0 0 0 0",
			"margin": "0px 20px 0px 0",
			"lg-margin": "0px 6px 0px 0px",
			"display": "block",
			"href": "/privacy",
			"font": "--base",
			"text-decoration-line": "initial",
			"color": "#c3c8d0",
			"hover-color": "white",
			"sm-padding": "0 0 15px 0",
			"md-white-space": "nowrap",
			"sm-order": "-1",
			"children": "Privacy Policy"
		}
	},
	"link3": {
		"kind": "Link",
		"props": {
			"padding": "0 0 0 0",
			"margin": "0px 20px 0px 0",
			"lg-margin": "0px 6px 0px 0px",
			"display": "block",
			"font": "--base",
			"text-decoration-line": "initial",
			"color": "#c3c8d0",
			"hover-color": "white",
			"sm-padding": "0 0 15px 0",
			"md-white-space": "nowrap",
			"sm-order": "-1",
			"children": "Terms and Conditions",
			"href": "/terms-and-conditions"
		}
	},
	"link4": {
		"kind": "Link",
		"props": {
			"padding": "0 0 0 0",
			"margin": "0px 0 0px 0",
			"lg-margin": "0px 6px 0px 0px",
			"display": "block",
			"font": "--base",
			"text-decoration-line": "initial",
			"color": "#c3c8d0",
			"hover-color": "white",
			"sm-padding": "0 0 15px 0",
			"md-white-space": "nowrap",
			"sm-order": "-1",
			"children": "Cookie Policy",
			"href": "/cookie-policy"
		}
	}
};

const Footer4 = props => {
	const {
		override,
		children,
		rest
	} = useOverrides(props, overrides, defaultProps);
	return <Section {...rest}>
		<Box {...override("box")}>
			<Box {...override("box1")}>
				<Box {...override("box2")}>
					<Text {...override("text")} />
					<Link {...override("link")} />
					<Link {...override("link1")} />
				</Box>
				<Box {...override("box3")}>
					<Text {...override("text1")} />
					<Text {...override("text2")} />
				</Box>
			</Box>
			<Box {...override("box4")}>
				<Link {...override("link2")} />
				<Link {...override("link3")} />
				<Link {...override("link4")} />
			</Box>
		</Box>
		{children}
	</Section>;
};

Object.assign(Footer4, { ...Section,
	defaultProps,
	overrides
});
export default Footer4;